import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import {
  PaddingProps,
  paddingFields,
} from '../../../page-builder/puck/reusable-props/padding';
import { Vip } from './vip';
import { QuillTextEditor } from '../../../page-builder/puck/reusable-props/quill-editor';
import { ReduxSelectorProps } from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { getcurrentDeviceType, getQuillEditorText } from '../../utils/helper';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type VipProps = {
  content: string;
  Title: CustomizeProps;
  Description: CustomizeProps;
  background: {
    color: string;
    isInherit: boolean;
  };
  border: IBorderValueProps;
};

export type VipComponentProps = VipProps &
  MarginProps &
  PaddingProps &
  showComponentProps;

export const VipComponent = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<VipComponentProps> => {
  return {
    label: (
      <CustomTooltip title="VipComponent">
        <span>VIP Component</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
      Title: {
        type: 'custom',
        render: ({ value, onChange }) => {
          return (
            <TextCustomInput
              showComponent={true}
              value={value}
              onChange={onChange}
              title="Title"
            />
          );
        },
      },
      Description: {
        type: 'custom',
        render: ({ value, onChange }) => {
          return (
            <TextCustomInput
              showComponent={true}
              value={value}
              onChange={onChange}
              title="Header 2"
            />
          );
        },
      },
      content: {
        ...QuillTextEditor('Description').content,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      Title: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        deviceType: 'desktop',
        text: 'VIP Club',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-base',
          tablet: 'text-base',
          desktop: 'text-base',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
      },
      Description: {
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        deviceType: 'desktop',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-base',
          tablet: 'text-base',
          desktop: 'text-base',
        },
      },
      content:
        '<p style="line-height:1.5;"><span style="font-size: 14px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna</span></p>',
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      ...borderProps,
      background: {
        color: '#ffffff',
        isInherit: false,
      },
    },
    render: ({
      margin,
      padding,
      content,
      Title,
      Description,
      showComponent,
      background,
      editMode,
      border,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const state = useAppSelector(state => state);
      const newInterpolation = getQuillEditorText(content, state);
      const newTitle = {
        ...Title,
        text: getQuillEditorText(Title?.text, state),
      };
      const newDescription = {
        ...Description,
        text: getQuillEditorText(Description?.text, state),
      };
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
              }}
              className={`flex flex-col w-full`}>
              <Vip
                Title={newTitle}
                currentDeviceType={currentDeviceType}
                Description={newDescription}
                content={newInterpolation}
                useAppSelector={useAppSelector}
                padding={padding}
                margin={margin}
                border={border}
                background={background}
              />
            </div>
          )}
        </>
      );
    },
  };
};
